import { Clickable } from '@turbocomplynpm/clickable';

export default Clickable;
